import { render, staticRenderFns } from "./databaseConfiguration.vue?vue&type=template&id=72f9d65b"
import script from "./databaseConfiguration.vue?vue&type=script&lang=js"
export * from "./databaseConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports